import logoPng from "@/assets/blondies-logo.png";
import logoAvif256 from "@/assets/blondies-logo-256.avif";
import logoAvif512 from "@/assets/blondies-logo-512.avif";
import logoWebp256 from "@/assets/blondies-logo-256.webp";
import logoWebp512 from "@/assets/blondies-logo-512.webp";
import heroJpg from "@/assets/hero-bg.jpg";
import heroAvif768 from "@/assets/hero-bg-768.avif";
import heroAvif1280 from "@/assets/hero-bg-1280.avif";
import heroAvif1920 from "@/assets/hero-bg-1920.avif";
import heroWebp768 from "@/assets/hero-bg-768.webp";
import heroWebp1280 from "@/assets/hero-bg-1280.webp";
import heroWebp1920 from "@/assets/hero-bg-1920.webp";

export type ImageSource = {
  type: string;
  srcSet: string;
};

export const logoImage = {
  src: logoPng,
  srcSet: `${logoPng} 512w`,
  sources: [
    { type: "image/avif", srcSet: `${logoAvif256} 256w, ${logoAvif512} 512w` },
    { type: "image/webp", srcSet: `${logoWebp256} 256w, ${logoWebp512} 512w` },
  ] satisfies ImageSource[],
  width: 512,
  height: 512,
};

export const heroImage = {
  src: heroJpg,
  srcSet: `${heroJpg} 1920w`,
  sources: [
    {
      type: "image/avif",
      srcSet: `${heroAvif768} 768w, ${heroAvif1280} 1280w, ${heroAvif1920} 1920w`,
    },
    {
      type: "image/webp",
      srcSet: `${heroWebp768} 768w, ${heroWebp1280} 1280w, ${heroWebp1920} 1920w`,
    },
  ] satisfies ImageSource[],
  width: 1920,
  height: 1280,
};

/** Preload the LCP logo as AVIF so mobile Chrome picks a ~12–25 KiB file. */
export const logoLcpPreload = {
  href: logoAvif256,
  imageSrcSet: `${logoAvif256} 256w, ${logoAvif512} 512w`,
  imageSizes: "176px",
  type: "image/avif",
};
